<a [href]="ntyCmButtonUrl" target="_blank" class="nty-cm-button terra-body">
  <ng-content select="ion-icon" />
  <ng-content />
</a>
